import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left text-no-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "text-left text-no-wrap"
}
const _hoisted_3 = {
  key: 1,
  class: "text-left text-no-wrap"
}
const _hoisted_4 = { class: "text-right text-no-wrap" }
const _hoisted_5 = { class: "text-right text-no-wrap" }
const _hoisted_6 = { class: "text-left" }
const _hoisted_7 = {
  key: 0,
  class: "text-left"
}
const _hoisted_8 = {
  key: 1,
  class: "text-left"
}
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = { class: "font-weight-bold" }
const _hoisted_12 = {
  key: 0,
  class: "text-left"
}
const _hoisted_13 = {
  key: 1,
  class: "text-left"
}
const _hoisted_14 = { class: "text-right font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createBlock(_component_v_table, { density: "compact" }, {
    default: _withCtx(() => [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_1, _toDisplayString(_ctx.$t("message.description")), 1),
          (_ctx.model.roles && _ctx.model.roles.includes('Owner'))
            ? (_openBlock(), _createElementBlock("th", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.$t("message.expression")) + " ", 1),
                _createVNode(_component_v_icon, {
                  size: "x-small",
                  color: "grey",
                  title: _ctx.$t('message.ownerOnly')
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-lock-outline", -1)
                  ]))]),
                  _: 1
                }, 8, ["title"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.model.roles && _ctx.model.roles.includes('Owner'))
            ? (_openBlock(), _createElementBlock("th", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.$t("message.calculation")) + " ", 1),
                _createVNode(_component_v_icon, {
                  size: "x-small",
                  color: "grey",
                  title: _ctx.$t('message.ownerOnly')
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-lock-outline", -1)
                  ]))]),
                  _: 1
                }, 8, ["title"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("message.defaultValue")), 1),
          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$tc("message.score",1)), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationScores, (locationScore, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", _hoisted_6, _toDisplayString(locationScore.description), 1),
            (_ctx.model.roles && _ctx.model.roles.includes('Owner'))
              ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(locationScore.function), 1))
              : _createCommentVNode("", true),
            (_ctx.model.roles && _ctx.model.roles.includes('Owner'))
              ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(locationScore.calculation), 1))
              : _createCommentVNode("", true),
            _createElementVNode("td", _hoisted_9, _toDisplayString(locationScore.defaultValue), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$filters.fixed(locationScore.score, 2,_ctx.$i18n.locale)), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("tfoot", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t("message.total")), 1),
          (_ctx.model.roles && _ctx.model.roles.includes('Owner'))
            ? (_openBlock(), _createElementBlock("td", _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.model.roles && _ctx.model.roles.includes('Owner'))
            ? (_openBlock(), _createElementBlock("td", _hoisted_13))
            : _createCommentVNode("", true),
          _cache[2] || (_cache[2] = _createElementVNode("td", { class: "text-left" }, null, -1)),
          _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$filters.fixed(_ctx.totalScore, 2,_ctx.$i18n.locale)), 1)
        ])
      ])
    ]),
    _: 1
  }))
}